export default __webpack_public_path__ + "static/media/Ltst-6.efd42676.jpg";